<template>
	<div></div>
</template>

<script>
	import {
		getItem,
		removeToken,
		removeItem
	} from '@/utils/auth'
	export default {
		data() {
			return {
				socket: null,
				timeoutObj: null,
				timeout: 30 * 1000,
				socketUrl: "",
				timeEnd: 0
			}
		},
		props: ['nowTime'],
		mounted() {
			let that = this
			// that.socketUrl = 'ws://192.168.31.73:10100/imserver/' + getItem('userInfo').account + '_' + this.nowTime.toString() + '_' + getItem('userInfo').tenantInfoId
			that.socketUrl = config.socketUrl + getItem('userInfo').account + '_' + this.nowTime.toString() + '_' +
				getItem('userInfo').tenantInfoId
			that.initWebSocket(that.socketUrl)
		},
		methods: {
			initWebSocket(url) {
				this.timeEnd++;
				if (this.timeEnd > 3) {
					this.outFun()
				} else {
					if (typeof WebSocket === 'undefined') {
						alert('您的浏览器不支持socket')
					} else {
						this.socket = new WebSocket(url)
						this.socket.onopen = this.open
						this.socket.onerror = this.error
						this.socket.onmessage = this.getMessage
						this.socket.onclose = this.websocketclose
					}
				}
			},
			open() {
				var self = this
				self.timeoutObj = window.setInterval(function() {
					if (self.socket.readyState === 1) {
						self.socket.send('heartCheck')
					}
				}, self.timeout)
			},
			error() {
				this.outFun()
			},
			getMessage(event) {
				let that = this
				if (event.data !== '连接成功') {
					let socketData = JSON.parse(event.data)
					if (socketData.socketType !== '5') {
						that.$emit('backSockertData', socketData)
					}
					// 单点登陆
					if (socketData.socketType === '15') {
						const ifOut = socketData.macs.includes(getItem('kakcrc'))
						if (!ifOut) {
							that.$message({
								message: '您的账号已在另一处登陆',
								type: 'warning',
								duration: '2000'
							});
							setTimeout(() => {
								removeToken()
								removeItem('differtime')
								that.$router.push({
									name: 'login'
								})
							}, 2000)
						}
					}
				} else {}
			},
			websocketclose() {
				let self = this
				window.clearInterval(self.timeoutObj)
				self.socket = null
				self.initWebSocket(self.socketUrl)
			},
			outFun() {
				let that = this
				window.clearInterval(self.timeoutObj)
				self.socket = null
				if (document.getElementsByClassName("el-notification right").length === 0) {
					that.$notify.warning({
						title: '网络环境不佳，请重新登录！'
					})
					setTimeout(() => {
						removeToken()
						removeItem('differtime')
						that.$router.push({
							name: 'login',
						})
					}, 2000)
				}
			}
		},
		destroyed() {
			let that = this
			window.clearInterval(that.timeoutObj)
			that.socket = null
		}
	}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/RobotSocket.vue